import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { BaseButtons, TextInputField } from "../../../common-components";
import { colors } from "../../../../themes/Colors";
import AccountScannerPopUp from "./account-scanner-op-up/AccountScannerPopUp";
import UserRegisterVehicleCard from "./user-register-vehicle-card/UserRegisterVehicleCard";
import ManageVehiclePopUp from "./manage-vehicle-pop-up/ManageVehiclePopUp";
import LinkedPopUpDisplay from "./linked-pop-up-display/LinkedPopUpDisplay";

const Vehicles = ({
  companyInformation,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
  loading,
}) => {
  const { width, height } = useWindowDimensions();

  const [searchText, setSearchtext] = useState("");
  const [search, setSearch] = useState("");

  const [scannerAccountPopUp, setScannerAccountPopUp] = useState(false);

  const [vehiclesArray, setVehiclesArray] = useState(null);
  const [vehiclesArrayDocs, setVehiclesArrayDocs] = useState(null);

  const [selectedVehicles, setSelectedVehicles] = useState(null);

  const [activeView, setActiveView] = useState("none");

  const [open, setOpen] = useState(false);
  const [selectedView, setSelectedView] = useState("list");

  const [filterTest, setFilterTest] = useState(false);
  const [filterTest1, setFilterTest1] = useState(false);
  const [addProductStep, setAddProductStep] = useState(1);
  const [regsitrationNr, setRegistrationNr] = useState("");
  const [vinNr, setVinNr] = useState("");
  const [licenceNr, setLicenceNr] = useState("");
  const [engineNr, setEngineNr] = useState("");
  const [make, setMake] = useState(null);
  const [makeArray, setMakeArray] = useState(null);
  const [originalMakeArray, setOriginalMakeArray] = useState([]);
  const [series, setSeries] = useState(null);
  const [seriesArray, setSeriesArray] = useState(null);
  const [enatisVehicleArray, setEnatisVehicleArray] = useState(null);
  const [originalEnatisVehicleArray, setOriginalEnatisVehicleArray] =
    useState(null);

  const [searchRegister, setSearchRegister] = useState(true);

  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [tableDisplay, setTableDisplay] = useState("enatis");

  const [selectedMake, setSelectedMake] = useState(null);
  const [makeCardHover, setMakeCardHover] = useState(null);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [seriesCardHover, setSeriesCardHover] = useState(null);

  const [addMake, setAddMake] = useState(false);
  const [addSeries, setAddSeires] = useState(false);
  const [makeImage, setMakeImage] = useState("");
  const [makeName, setMakeName] = useState("");
  const [seriesImage, setSeriesImage] = useState("");
  const [seriesName, setSeriesName] = useState("");

  const [selectedMakeEdit, setSelectedMakeEdit] = useState("");
  const [selectedMakeEditImage, setSelectedMakeEditImage] = useState("");

  const [selectedSeriesEdit, setSelectedSeriesEdit] = useState("");
  const [selectedSeriesEditImage, setSelectedSeriesEditImage] = useState("");

  const [userRegisteredVehicles, setUserRegisteredVehicles] = useState(null);
  const [originalUsersArray, setOriginalUsersArray] = useState(null);

  const [linkUserPopUp, setLinkedUserPopUp] = useState(false);

  console.log("selected", selectedVehicles);

  const GetAllVehicles = async () => {
    // console.log("inside get all vehicles");
    // console.log("Auths", auth);
    setLoading(true);
    // console.log("loading");
    try {
      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com/userVehicles/getUserVehicleList",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: companyInformation.companyId,
          }),
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        // setPrivateInfoPopUp(false);
        setVehiclesArray(respnseData.vehicleList);
        setVehiclesArrayDocs(respnseData.vehicleListDocs);
        // setClose(false);
        setLoading(false);
        // setBarcodeData(null);
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (companyInformation) {
      GetAllVehicles();
    }
  }, []);
  // get scanner accoujnt

  // if no scanner account display create button

  // therwise display account info to admin to allow mobile login

  return (
    <div
      style={{
        flex: 1,
        // borderStyle: "solid",
        maxHeight: height - 70,
        height: height - 70,
        minHeight: height - 70,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          //   borderStyle: "solid",
          //   borderWidth: 1,
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          //   backgroundColor: colors.white,
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            backgroundColor: colors.white,
            borderRadius: 4,
            display: "flex",
            marginLeft: 10,
          }}
        >
          <TextInputField
            mini={true}
            marginTop={-5}
            // invert={true}
            placeholder={"type here to search"}
            height={20}
            value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
          />
        </div>
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"CLEAR"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => {
            setSearchtext("");
            setSearch("");
          }}
        />{" "}
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SEARCH"}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
          onClick={() => setSearch(searchText)}
        />
        <div style={{ marginLeft: 20, fontWeight: "bold" }}>
          AGENCY OWNED VEHICLES
        </div>
        <div style={{ marginLeft: 10, position: "relative" }}>
          {/* <BaseButtons
            label={"FILTER"}
            borderRadius={8}
            backgroundColor={colors.primaryBlue}
            onClick={() => setFilterPopUp(filterPopUp ? false : true)}
          /> */}
          {/* {filterPopUp ? (
            <div
              style={{
                position: "absolute",
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 4,
                bottom: -325,
                minHeight: 300,
                width: 300,
                left: 10,
                WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              }}
            >
              <div
                style={{ marginTop: 10, marginLeft: 10, fontWeight: "bold" }}
              >
                FILTER OPTIONS
              </div>
              <div
                style={{
                  marginTop: 4,
                  marginLeft: 10,
                  fontWeight: "bold",
                  fontSize: 12,
                  opacity: 0.7,
                }}
              >
                please select the options you would like to be able to view
              </div>
              <CheckInput
                label={"ALL"}
                onClick={() => setMainfilterChoice("all")}
                selected={mainfilterChoice === "all" ? true : false}
              />
              <CheckInput
                label={"PROVINCES"}
                onClick={() => setMainfilterChoice("province")}
                selected={mainfilterChoice === "province" ? true : false}
              />
              <CheckInput
                label={"VEHICLE MAKE"}
                onClick={() => setMainfilterChoice("make")}
                selected={mainfilterChoice === "make" ? true : false}
              />
              <CheckInput
                label={"CUSTOME REQUEST"}
                onClick={() => setMainfilterChoice("custom")}
                selected={mainfilterChoice === "custom" ? true : false}
              />

              {mainfilterChoice === "all" ? (
                <div
                  style={{
                    marginTop: 60,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  "No extra options currently availible"
                </div>
              ) : null}
              {mainfilterChoice === "province" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <div style={{ marginBottom: 4, fontSize: 12 }}>
                    List of provinces
                  </div>
                  <div style={{ display: "flex" }}>
                    <CheckInput
                      label={"EC"}
                      onClick={() => setEc(ec ? false : true)}
                      selected={ec}
                    />
                    <CheckInput
                      label={"FS"}
                      onClick={() => setFs(fs ? false : true)}
                      selected={fs}
                    />
                    <CheckInput
                      label={"GP"}
                      onClick={() => setGp(gp ? false : true)}
                      selected={gp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"KN"}
                      onClick={() => setKn(ec ? false : true)}
                      selected={kn}
                    />
                    <CheckInput
                      label={"LP"}
                      onClick={() => setLp(fs ? false : true)}
                      selected={lp}
                    />
                    <CheckInput
                      label={"MP"}
                      onClick={() => setMp(mp ? false : true)}
                      selected={mp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"NC"}
                      onClick={() => setNc(ec ? false : true)}
                      selected={nc}
                    />
                    <CheckInput
                      label={"NW"}
                      onClick={() => setNw(fs ? false : true)}
                      selected={nw}
                    />
                    <CheckInput
                      label={"WC"}
                      onClick={() => setWc(gp ? false : true)}
                      selected={wc}
                    />
                  </div>
                </div>
              ) : null}
              {mainfilterChoice === "make" ? (
                <div
                  style={{
                    marginTop: 40,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputField mini={true} labelTitle={"Vehicle Make"} />
                </div>
              ) : null}
              {mainfilterChoice === "custom" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputFieldArea
                    height={80}
                    size={"80%"}
                    mini={true}
                    labelTitle={"Custome search"}
                  />
                </div>
              ) : null}
            </div>
          ) : null} */}
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"LINKED USERS"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => setLinkedUserPopUp(true)}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SCANNER ACCOUNT"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          onClick={() => setScannerAccountPopUp(true)}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"REFRESH"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => setRefresh(refresh ? false : true)}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      {/* // header */}
      <div
        style={{
          width: "100%",
          backgroundColor: colors.secondaryDarkBlue,
          height: 40,
          display: "flex",
        }}
      >
        <div
          style={{
            flex: 0.15,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ marginLeft: 10 }}>REGISTER NR</div>
          </div>
        </div>
        <div
          style={{
            flex: 0.15,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ marginLeft: 10 }}> LICENCE NR</div>
          </div>
        </div>
        <div
          style={{
            flex: 0.2,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}> VIN NR</div>
        </div>
        <div
          style={{
            flex: 0.2,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}> ENGINE NR</div>
        </div>
        <div
          style={{
            flex: 0.1,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}> MAKE</div>
        </div>
        <div
          style={{
            flex: 0.1,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%" }}>SERIES</div>
        </div>
        <div
          style={{
            flex: 0.1,
            color: colors.white,
            fontWeight: "bold",
            fontSize: 12,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          ACTIONS
        </div>
      </div>
      <div
        style={{
          flex: 1,

          overflowY: "scroll",
          alignItems: "center",
          overflowX: "hidden",
        }}
      >
        {vehiclesArray
          ? vehiclesArray.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                  }}
                >
                  <UserRegisterVehicleCard
                    vehicle={item}
                    onManageClick={() => {
                      setActiveView("manage");
                      setSelectedVehicles(item);
                    }}
                  />
                </div>
              );
            })
          : null}
      </div>
      {scannerAccountPopUp ? (
        <AccountScannerPopUp
          setClose={setScannerAccountPopUp}
          companyInformation={companyInformation}
          auth={auth}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
        />
      ) : null}
      <ManageVehiclePopUp
        selectedVehicle={selectedVehicles}
        activeView={activeView}
        setActiveView={setActiveView}
        SubmitHandler={null}
        regsitrationNr={regsitrationNr}
        setRegistrationNr={setRegistrationNr}
        vinNr={vinNr}
        setVinNr={setVinNr}
        licenceNr={licenceNr}
        setLicenceNr={setLicenceNr}
        engineNr={engineNr}
        setEngineNr={setEngineNr}
        make={make}
        setMake={setMake}
        series={series}
        setSeries={setSeries}
        tableDisplay={tableDisplay}
        auth={auth}
        setSelectedVehicle={setSelectedVehicles}
        setMessage={setMessage}
      />
      <LinkedPopUpDisplay
        auth={auth}
        display={linkUserPopUp}
        onCloseClick={() => setLinkedUserPopUp(false)}
      />
    </div>
  );
};

export default Vehicles;
